import React from 'react';
import { ScrollView, Text, View } from 'react-native';
import i18n from 'i18n-js';

import { Link as ILink } from '@interfaces/search';

import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import { SmallLoading } from '@components/loading';
import { isPhone } from '@helpers';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import Link from './components/Link';

const Links = ({ C, links, isLoading }: { C: ColorFunction; links: ILink[]; isLoading: boolean }) => {
  if (isLoading) {
    return (
      <View style={{ flex: 1, marginTop: scale(20) }}>
        <SmallLoading />
      </View>
    );
  }

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: scale(isPhone ? 20 : 45),
      }}
    >
      <Text
        style={[
          font.Body,
          {
            marginBottom: scale(20),
            color: C('Label / Light / Primary'),
            textAlign: 'center',
          },
        ]}
      >
        {i18n.t('The links below are used to facilitate automatic linking of production Batches of NC Files to Jobs')}
      </Text>
      <View style={{ flex: 1, width: '100%' }}>
        <ScrollView contentContainerStyle={{ paddingBottom: scale(10), paddingHorizontal: scale(10) }}>
          <View>
            {links.length ? (
              <View testID={TEST_IDS.ncFileLinks.list}>
                {links.map((link, index) => (
                  <View key={index} testID={TEST_IDS.ncFileLinks.item(index)}>
                    {index > 0 && (
                      <Text style={[font['Subhead 2'], { alignSelf: 'center', color: C('Label/Light/Secondary'), marginVertical: scale(7) }]}>
                        {i18n.t('and')}
                      </Text>
                    )}
                    <Link {...{ C, link, index }} />
                  </View>
                ))}
              </View>
            ) : (
              <Text testID={TEST_IDS.ncFileLinks.empty} style={[font.Subhead, { color: C('Label/Light/Secondary'), alignSelf: 'center', marginTop: scale(20) }]}>
                {i18n.t('Links not found')}
              </Text>
            )}
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default ColorWrapper(Links);
